import { ReactComponent as LocationIcon } from '../../Assets/location-icon.svg';
import useTranslate from '../../Hooks/useTranslate';
import Text from '../../Style-guide/Text';

const CourtInfo = ({ court }) => {
  const { address, contacts, priceForSixtyMin, priceForNinetyMin } = court;
  const tr = useTranslate();

  return (
    <section className='court-info'>
      <address className='court-contacts'>
        <Text size='MD'>{contacts}</Text>
      </address>

      <address className='court-address'>
        <Text size='MD'>
          <LocationIcon height='16' width='16' className='location-icon' />
          {address}
        </Text>
      </address>

      <section className='price-info'>
        {priceForSixtyMin ? (
          <Text size='SM'>{`${priceForSixtyMin.toLocaleString('en-US')} AMD (${tr('60_min')})`}</Text>
        ) : null}
        {priceForNinetyMin ? (
          <Text size='SM'>{`${priceForNinetyMin.toLocaleString('en-US')} AMD (${tr('90_min')})`}</Text>
        ) : null}
      </section>
    </section>
  );
};

export default CourtInfo;
